import { UserContextExperimentGroup, getExperimentInt } from '@reverbdotcom/commons/src/user_context_helpers';
import React, { FC } from 'react';
import { ExperimentContext } from './experiment_block';

export type ExperimentGroupValue = ReturnType<typeof getExperimentInt>;
export type ExperimentGroupId = 'no-exp' | UserContextExperimentGroup;

export interface ExperimentGroupProps {
  groups: ExperimentGroupId[];
}

const experimentGroupToInt = (group: ExperimentGroupId): ExperimentGroupValue => {
  if (group === 'no-exp') { return -2; }
  return getExperimentInt({ value: group });
};

const ExperimentGroup: FC<ExperimentGroupProps> = (props) => {
  const context = React.useContext(ExperimentContext);
  const expGroups = props.groups.map(experimentGroupToInt);

  if (!expGroups.includes(context.expGroup)) { return <></>; }

  return <>
    {props.children}
  </>;
};

export default ExperimentGroup;
